<section [@routerTransition] *ngIf="plano">
    <div *ngIf="mostrarVoltar" class="row align-items-center botao-voltar" (click)="voltar()">
        <button class="btn-back">
            <i class="fa fa-arrow-left"></i>
        </button>
        <span>Voltar</span>
    </div>
    <div class="row">
        <div [ngClass]="plano.free ? 'col-12' : 'col-md-4 col-12'">
            <div class="detalhes-compras-container" [ngClass]="{'w-100 d-flex flex-column': plano.free}">
                <p>Detalhes da compra</p>
                <exibir-plano *ngIf="plano" [plano]="plano" [showOptions]="false" [isAnual]="isAnual"></exibir-plano>
                <div class="datas-container">
                    <div class="linha-data">
                        <div class="info-esquerda col-8">
                            <i class="hgi hgi-stroke hgi-save-money-dollar"></i>
                            <span>Próxima Cobrança:</span>
                        </div>
                        <div class="info-direita col-4">
                            {{ dataAtual | date: 'dd/MM/yyyy' }}
                        </div>
                    </div>

                    <div class="linha-data" *ngIf="pagamentoSelecionado != 'CARTAO'">
                        <div class="info-esquerda col-8">
                            <i class="hgi hgi-stroke hgi-calendar-03"></i>
                            <span>Data de Vencimento:</span>
                        </div>
                        <div class="info-direita col-4">
                            {{ dataVencimento | date: 'dd/MM/yyyy' }}
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="plano.free" class="mt-3 d-flex justify-content-end">
                <button [disabled]="saving" (click)="realizarPagamento()" class="btn primary-white-button">
                    Assinar <i class="hgi hgi-stroke hgi-arrow-right-02"></i>
                </button>
            </div>
        </div>

        <div *ngIf="!plano.free" class="col-md-8 col-12 pagamento-container">
            <metodos-pagamentos #metodosPagamento [valor]="isAnual ? plano.valorAnual : plano.valorMensal" />
            <div class="mt-3 d-flex justify-content-end btn-pagamento-container">
                <button [disabled]="saving" (click)="realizarPagamento()" class="btn primary-white-button">
                    Realizar Pagamento <i class="hgi hgi-stroke hgi-arrow-right-02"></i>
                </button>
            </div>
        </div>
    </div>
</section>